<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';
import CustomSidebarMenusAPI from 'next/sidebar/customMenus/api';

const route = useRoute();
const menu = ref(null);
const isLoading = ref(true);
const hasError = ref(false);

const menuId = computed(() => route.params.menuId);

const load = async () => {
  isLoading.value = true;
  hasError.value = false;
  try {
    const { data } = await CustomSidebarMenusAPI.show(menuId.value);
    menu.value = data;

    if (data?.embed_type === 'direct_link' && data?.url) {
      window.open(data.url, '_blank', 'noopener,noreferrer');
    }
  } catch (error) {
    hasError.value = true;
    useAlert('Não foi possível carregar este menu');
  } finally {
    isLoading.value = false;
  }
};

onMounted(load);
watch(menuId, load);
</script>

<template>
  <div class="flex flex-col w-full h-full min-h-0 bg-n-background">
    <div v-if="isLoading" class="flex items-center justify-center flex-grow">
      <Spinner />
    </div>

    <div
      v-else-if="hasError || !menu"
      class="flex items-center justify-center flex-grow"
    >
      <p class="text-sm text-n-slate-11">Este menu não foi encontrado.</p>
    </div>

    <iframe
      v-else-if="menu.embed_type === 'iframe'"
      :src="menu.url"
      :title="menu.label"
      class="flex-grow w-full border-0"
    />

    <div
      v-else
      class="flex flex-col items-center justify-center flex-grow gap-2 text-center px-4"
    >
      <p class="text-sm text-n-slate-11">
        Abrindo "{{ menu.label }}" em uma nova aba…
      </p>
      <a
        :href="menu.url"
        target="_blank"
        rel="noopener noreferrer"
        class="text-sm text-n-brand hover:underline"
      >
        Não abriu automaticamente? Clique aqui.
      </a>
    </div>
  </div>
</template>
